import { ReactElement } from 'react';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { TeamInfoSkeleton } from '../TeamInfo/Skeleton';

const MATCH_STATISTIC_LAST_GAMES_COUNT = 5;

export const MatchStatisticLastGamesSkeleton = (): ReactElement => {
  return (
    <>
      <div className="match-stat-wrapper__tab-row">
        <div className="match-stat-col match-stat-col-sm">
          <Skeleton.Button
            active
            className="match-stat-wrapper__tab-row__skeleton-lg"
          />
        </div>
        <div className="match-stat-col match-stat-col-lg match-stat-spacer">
          <Skeleton.Button
            active
            className="match-stat-wrapper__tab-row__skeleton-sm"
          />
        </div>
        <div className="match-stat-col match-stat-col-lg">
          {createArray(2).map(key => (
            <div className="match-stat-cube" key={key}>
              <Skeleton.Button
                active
                className="match-stat-wrapper__tab-row__skeleton-sm"
              />
            </div>
          ))}
        </div>
      </div>

      {createArray(2).map(key => (
        <div
          key={key}
          className="match-stat-wrapper__tab-row match-stat-wrapper__tab-result"
        >
          <div className="match-stat-col match-stat-col-sm">
            <TeamInfoSkeleton />
          </div>

          <div className="match-stat-col match-stat-col-lg">
            {createArray(MATCH_STATISTIC_LAST_GAMES_COUNT).map(key => (
              <div className="match-stat-cube" key={key}>
                <Skeleton.Button
                  active
                  className="match-stat-wrapper__tab-row__skeleton-sm"
                />
              </div>
            ))}
          </div>

          <div className="match-stat-col match-stat-col-lg">
            {createArray(2).map(key => (
              <div className="match-stat-cube" key={key}>
                <Skeleton.Button
                  active
                  className="match-stat-wrapper__tab-row__skeleton-sm"
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};
